import { adminHttpClient } from "../commons/adminHttpClient";

const getProgramAuditReportExcel = (id: string): Promise<any> => {
  return adminHttpClient.get(`/ProgramAudits/View/GenerateExcel/${id}`);
};

export default getProgramAuditReportExcel;